import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  titlesWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 15
  },
  leftSide: {
    color: colour.grey[100],
    fontSize: 18,
    fontWeight: 600
  },
  rightSide: {
    color: colour.grey[300],
    fontSize: 16,
    fontWeight: 400
  }
});
